// extracted by mini-css-extract-plugin
export default {"container":"CropImage_container__E7hDY"};